import { Component, Input } from '@angular/core';
import { AbstractPage } from "../../pages/_com/abstract-page";

/**
 * Generated class for the TabetakotoaruRinyushokuViewComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'app-tabetakotoaru-rinyushoku-view',
  templateUrl: 'tabetakotoaru-rinyushoku-view.html'
})
export class TabetakotoaruRinyushokuViewComponent extends AbstractPage {

  @Input() rinyushoku_tabetakotoaru_shokuzai: any;

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/components/tabetakotoaru-rinyushoku-view/tabetakotoaru-rinyushoku-view.ts